import type { AnnotationStore } from '../../../transcription/types/annotation';
import { resolveTranscriptionData } from '../../resolver/transcription/transcription-resolver';
import type { ResolvedValues, ResolveValuePermutations } from '../../type/common/types';
import type { TranscriptionResolver } from '../../type/resolver';
import { calculateCrossProductOfResolvedValues } from '../calculate-cross';
import { QaCheckError } from '../error';
export const getFetchedDataForRule = (bindings: TranscriptionResolver[], entityData: {
  annotationStore: AnnotationStore;
}): ResolveValuePermutations<'ANNOTATION'> | QaCheckError => {
  const {
    annotationStore
  } = entityData;
  const aliasToResolvedValueMap: {
    [alias: string]: ResolvedValues<'ANNOTATION'>;
  } = {};
  for (const binding of bindings) {
    switch (binding.entityType) {
      case 'ANNOTATION':
        {
          const resolvedValues = resolveTranscriptionData(binding, annotationStore);
          if (resolvedValues instanceof QaCheckError) {
            return resolvedValues;
          }
          aliasToResolvedValueMap[binding.alias] = resolvedValues;
          break;
        }
    }
  }
  return calculateCrossProductOfResolvedValues(aliasToResolvedValueMap);
};